import { render, staticRenderFns } from "./RenderDetails.vue?vue&type=template&id=41bd5452&scoped=true&"
import script from "./RenderDetails.vue?vue&type=script&lang=js&"
export * from "./RenderDetails.vue?vue&type=script&lang=js&"
import style0 from "./RenderDetails.vue?vue&type=style&index=0&id=41bd5452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bd5452",
  null
  
)

export default component.exports